import React from "react";

export default function EmployeePermissionComponent() {
  return <div>ยังไม่เปิดใช้งาน</div>;
}
